import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const InboundSupplyOrderUnloadingTypeRBAC = {
  pageID: 'ef90aad2cf3c3a46aa4dbf3c6a13e676',
  elementID: {
    ButtonSubmit: 'a7644bc7f3ff0565c2b066293229f8b1',
  },
} as const

export const useRBACInboundSupplyOrderUnloadingTypePage = createUseRBAC(
  InboundSupplyOrderUnloadingTypeRBAC.elementID,
)
export type UseRBACInboundSupplyOrderUnloadingTypePageType = ReturnType<
  typeof useRBACInboundSupplyOrderUnloadingTypePage
>
